<template>
    <!-- <nav class="navbar navbar-expand-sm navbar-light bg-light d-lg-none mb-3"> -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-3 d-lg-none">
        <div class="container">
            <b-row class="pb-4 pt-3 no-gutters">
                <b-col class="mx-1">
                    <app-btn-home />
                </b-col>
                <b-col class="mx-0">
                    <app-btn-back />
                </b-col>
            </b-row>
            <a href="#" class="navbar-brand">
                <!-- <b-img src="img/banner_vecindapp_sm.png" style="max-width: 200px;"></b-img> -->
                <b-img v-if="!currentClient || !currentClient.banner_url" src="img/banner_vecindapp_new_sm.png" style="max-width: 160px"></b-img>
                <b-img v-else :src="currentClient.banner_url" style="max-width: 160px"></b-img>
            </a>
            <button type="button" class="navbar-toggler" @click.prevent="toggleMenu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse bg-light" style="z-index: 99" id="mobile-menu">
                <ul class="navbar-nav">
                    <li class="navbar-item" v-for="menuItem in menu" :key="menuItem.id">
                        <div class="nav-link">
                            <h5 class="text-secondary">{{ menuItem.name }}</h5>
                            <ul class="navbar-nav ml-3">
                                <li class="navbar-item" v-for="item in menuItem.menuItems" :key="item.id">
                                    <a href="#" class="nav-link text-primary" @click.prevent="navigateTo(item.route)"
                                        ><strong>{{ item.name }}</strong></a
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="navbar-item">
                        <div class="nav-link">
                            <h5><i class="fas fa-user"></i> Opciones del usuario</h5>
                            <ul>
                                <li @click.prevent="goToProfile" class="nav-link">Perfil</li>
                                <li v-if="currentProfile.slug == 'interno'" @click.prevent="goToTutorial" class="nav-link">Ver Tutorial</li>
                                <li
                                    v-if="currentProfile.slug == 'administrador' || currentProfile.slug == 'administrativo'"
                                    @click.prevent="goToLogout"
                                    class="nav-link"
                                >
                                    Configuración
                                </li>
                                <li v-if="currentProfile.slug == 'vigilante'" @click.prevent="releaseShift" class="nav-link">
                                    Entregar turno
                                </li>
                                <li @click.prevent="openSupportPage" class="nav-link">Soporte</li>
                                <li v-if="currentProfile.slug == 'interno'"  @click.prevent="onDeleteAccount" class="nav-link">Eliminar cuenta</li>
                                <li @click.prevent="goToLogout" class="nav-link">Cerrar Sesión</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['menu', 'currentShift']),
        
    },
    methods: {
        navigateTo(route) {
            this.toggleMenu()
            if (this.$route.name === route) return
            this.$router.push({ name: route })
        },
        toggleMenu() {
            $('#mobile-menu').collapse('toggle')
        },
        goToProfile() {
            this.$emit('profile')
            this.toggleMenu()
        },
        goToLogout() {
            this.$emit('logout')
            this.toggleMenu()
        },
        goToTutorial() {
            window.open(`https://youtu.be/t66clohMrig`, '_blank')
        },
        releaseShift() {
            if (!this.currentShift) return
            this.$router.push({
                name: 'endShift',
                params: {
                    currentShiftId: this.currentShift.id,
                },
            })
        },
        openSupportPage() {
            this.$router.push({
                name: 'supportReport',
            })
        },
        async onDeleteAccount(){
            try {
                const value = await this.$bvModal.msgBoxConfirm(`¡No queremos que te vayas! Pero si decides continuar con la eliminación de tu cuenta, ten en cuenta que no recibirás más notificaciones de la administración y la vigilancia. Para reactivar tu cuenta en el futuro, por favor, contacta a la administración.`, {
                    title: 'Confirmar eliminación de cuenta',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Confirmar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                if (value) {
                    const { data } = await this.$repo.post(`people/${this.currentPerson.id}/delete-account`)
                    if(data.message){
                        toastr.success('Cuenta eliminada satisfactoriamente')
                        this.$router.replace('/')
                    }
                }
            } catch (error) {
                toastr.error('Ocurrió un error al eliminar la cuenta, por favor intenta de nuevo más tarde')
            }
        }
    },
}
</script>

<style></style>
